import React from "react";

const RecieveArrowIcon = ({ width, height, color }) => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 1.41L13.59 0L2 11.59V5H0V15H10V13H3.41" fill="#181818" />
    </svg>
  );
};

export default RecieveArrowIcon;
